// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessOilCanSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m5.447 4.724 8.447 4.223a.5.5 0 0 0 .224.053H16V8h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H18v1h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H11.92a3 3 0 0 1-3-3v-3.795a.5.5 0 0 0-.144-.351L4.861 8.876A3 3 0 0 1 4 6.772V5.618a1 1 0 0 1 1.447-.894zM3.49 15.694c-.154.36-.283.692-.372.968a3.712 3.712 0 0 0-.096.342 1.316 1.316 0 0 0-.022.14c0 .526.448.952 1 .952s1-.426 1-.952l-.003-.034a1.316 1.316 0 0 0-.02-.106 3.712 3.712 0 0 0-.095-.342c-.09-.276-.218-.607-.372-.967-.13-.306-.275-.623-.42-.93-.035-.074-.145-.074-.18 0-.145.307-.29.624-.42.93zm2.873-.716c.165.386.317.774.43 1.124.105.324.207.705.207 1.042C7 18.721 5.657 20 4 20s-3-1.279-3-2.856c0-.336.102-.718.207-1.042.113-.35.265-.738.43-1.124.33-.774.733-1.594 1.03-2.18.542-1.064 2.124-1.064 2.665 0 .298.586.7 1.406 1.03 2.18z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessOilCanSolid;
